<template>
  <div>
    <FilterOverview title="Kunden-Dublettenprüfung" :showFilterInitially="false" :showFilterButton="false">
      <template #toolbar-left>
        <button
          type="button"
          class="icon-button filter-button d-flex justify-content-center p-0 mr-4"
          :class="{ 'filter-button--aktiv': isFilterActive }"
          v-b-tooltip.hover.bottom
          title="Filter anpassen"
          @click="showFilter = !showFilter"
        >
          <span class="d-flex align-items-center"><Funnel :size="20" /></span>
        </button>
        <KundeDublettenConfirmationTableToolbarBase
          :shouldRefresh="isBusy"
        ></KundeDublettenConfirmationTableToolbarBase>
        <template v-if="isFilterActive">
          <div class="subheader-separator subheader-separator-ver mt-4 mb-2 mr-4 bg-gray-300"></div>
          <div
            class="icon-button d-flex align-items-center justify-content-center text-danger"
            @click="onReset"
            v-b-tooltip.hover.bottom
            title="Filter zurücksetzen"
          >
            <FunnelX :size="20" />
          </div>
        </template>
      </template>
      <template #toolbar-right>
        <b-button
          size="sm"
          class="dialog-btn-secondary"
          @click="$bvModal.show('modal-kunde-duplicates-merge')"
        >
          {{ $t('DUBLETTEN.MANUALMERGE') }}
        </b-button>
        <KundenDuplicatesMergeModal @duplicate-created="onReload"></KundenDuplicatesMergeModal>
      </template>
      <template #table>
        <KundeDublettenConfirmationTable
          ref="table"
          :filter="kundeDublettenConfirmationFilterArray"
          :appliedFilter="appliedKundeDublettenConfirmationFilter"
          :expand="kundeDublettenExpand"
          :showFilter="showFilter"
          @update:showFilter="showFilter = $event"
          @save-filter="onSaveFilter"
          @reset-filter="onReset"
        ></KundeDublettenConfirmationTable>
      </template>
    </FilterOverview>
  </div>
</template>

<script>
import KundeDublettenConfirmationTable from '@/components/kunden/dubletten-confirmation-table.vue';
import KundeDublettenConfirmationTableToolbarBase from '@/components/kunden/dubletten-confirmation-table-toolbar-base.vue';
import KundenDuplicatesMergeModal from '@/components/kunden/kunden-duplicates-merge-modal.vue';
import FilterOverview from '@/components/common/filter-overview.vue';

import {
  SET_APPLIED_FILTER,
  SET_ALL_FILTER_TO_INTIAL,
} from '@/core/kunden/stores/kunden-dubletten-confirmation-filter.module';
import { Funnel, FunnelX } from 'lucide-vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    KundeDublettenConfirmationTable,
    KundeDublettenConfirmationTableToolbarBase,
    KundenDuplicatesMergeModal,
    FilterOverview,
    Funnel,
    FunnelX,
  },
  data() {
    return {
      showFilter: false,
      isFilterActive: false,
    };
  },
  computed: {
    ...mapGetters(['kundeDublettenConfirmationFilterArray']),
    ...mapState({
      kundeDublettenExpand: state => state.kundeDublettenConfirmationFilter.expand,
      appliedKundeDublettenConfirmationFilter: state =>
        state.kundeDublettenConfirmationFilter.appliedKundeDublettenConfirmationFilter,
      kundeDublettenConfirmationFilter: state => state.kundeDublettenConfirmationFilter.filter,
      isBusy: state => state.kundeDublettenConfirmationFilter.isLoading,
    }),
  },
  methods: {
    onReset() {
      this.$store.commit(SET_ALL_FILTER_TO_INTIAL);
      this.$store.commit(SET_APPLIED_FILTER, this.kundeDublettenConfirmationFilter);
      this.isFilterActive = false;
      this.showFilter = false;
    },
    onSaveFilter() {
      this.$store.commit(SET_APPLIED_FILTER, this.kundeDublettenConfirmationFilter);
      this.isFilterActive = true;
      this.showFilter = false;
    },
    onReload() {
      this.$refs.table?.refreshKunden();
    },
  },
};
</script>
